import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";

export default function AddUpdateScreen({
  type,
  getAxiosInstance,
  Toast,
  screenUp,
  getCountries,
  getStates,
  getCities,
  getBuildings,
  getFloors,
  getScreens,
}) {
  const [IsShowing, setIsShowing] = useState(false);
  const [screen, setScreen] = useState("");
  const [password, setPassword] = useState("");
  const [floor, setFloor] = useState("");
  const [building, setBuilding] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [inputCountry, setInputCountry] = useState("");
  const [inputState, setInputState] = useState("");
  const [inputCity, setInputCity] = useState("");
  const [inputBuilding, setInputBuilding] = useState("");
  const [inputFloor, setInputFloor] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  //   dropdown options
  const [countryOpt, setCountryOpt] = useState("");
  const [allCountry, setAllCountry] = useState([]);

  const [stateOpt, setStateOpt] = useState("");
  const [allState, setAllState] = useState([]);

  const [cityOpt, setCityOpt] = useState("");
  const [allCity, setAllCity] = useState([]);

  const [buildingOpt, setBuildingOPt] = useState("");
  const [allBuilding, setAllBuilding] = useState([]);

  const [floorOpt, setFloorOpt] = useState("");
  const [allFloor, setAllFloor] = useState([]);

  useEffect(() => {
    if (screenUp) {
      setScreen(screenUp.name);
      setFloor(screenUp.floor);
      setBuilding(screenUp.building);
      setCity(screenUp.city);
      setState(screenUp.state);
      setCountry(screenUp.country);
    }
  }, [screenUp]);

  const fetchCountryData = () => getCountries(inputCountry);
  const fetchStateData = () => getStates(inputState, country?._id);
  const fetchCityData = () => getCities(inputCity, country?._id, state?._id);
  const fetchBuildingData = () =>
    getBuildings(inputBuilding, country?._id, state?._id, city?._id);
  const fetchFloorData = () =>
    getFloors(inputFloor, country?._id, state?._id, city?._id, building?._id);

  // get country option
  useEffect(() => {
    const params = {};
    getAxiosInstance()
      .post("/admin/countries", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        console.log(res.data.result);
        setAllCountry(res.data.result);
      })
      .catch((err) => console.log(err));
  }, []);

  // get states option
  useEffect(() => {
    let formdata = new FormData();
    //add three variable to form
    formdata.append("country", country);
    console.log({ inputCountry });
    // const data = JSON.parse(country);
    getAxiosInstance()
      .post(
        "/admin/states",
        { country: countryOpt }
        // {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllState(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [countryOpt]);

  // get cities option
  useEffect(() => {
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/cities",
        { state: stateOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllCity(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [stateOpt]);

  // get buildings option
  useEffect(() => {
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/buildings",
        { city: cityOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllBuilding(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [cityOpt]);

  // get floor options
  useEffect(() => {
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/floors",
        { building: buildingOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllFloor(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [buildingOpt]);

  useEffect(() => {
    if (screenUp) {
      setFloorOpt(screenUp.floor._id);
      setBuildingOPt(screenUp.building._id);
      setCityOpt(screenUp.city._id);
      setStateOpt(screenUp.state._id);
      setCountryOpt(screenUp.country._id);
    }
  }, []);

  const addScreen = () => {
    if (countryOpt === "" || !countryOpt)
      return Toast.fire({ icon: "error", title: "Country selection required" });
    if (stateOpt === "" || !stateOpt)
      return Toast.fire({ icon: "error", title: "State selection required" });
    if (cityOpt === "" || !cityOpt)
      return Toast.fire({ icon: "error", title: "City selection required" });
    if (buildingOpt === "" || !buildingOpt)
      return Toast.fire({
        icon: "error",
        title: "Building selection required",
      });
    if (floorOpt === "" || !floorOpt)
      return Toast.fire({ icon: "error", title: "Floor selection required" });
    if (screen.trim() === "")
      return Toast.fire({ icon: "error", title: "Screen name required." });
    if (!screenUp && password.trim() === "")
      return Toast.fire({ icon: "error", title: "Screen password required." });

    setIsLoading(true);
    let link = "/admin/add-screen";
    let params = {
      name: screen,
      password,
      //   floor: floor?._id,
      //   building: building?._id,
      //   city: city?._id,
      //   state: state?._id,
      //   country: country?._id,
      floor: floorOpt,
      building: buildingOpt,
      city: cityOpt,
      state: stateOpt,
      country: countryOpt,
    };
    if (screenUp) {
      params = {
        id: screenUp._id,
        name: screen,
        password,
        floor: floorOpt,
        building: buildingOpt,
        city: cityOpt,
        state: stateOpt,
        country: countryOpt,
      };
      link = "/admin/update-screen";
    }

    const data = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    getAxiosInstance()
      .post(link, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        // console.log(res.data)
        if (res.data.status === "success") {
          Toast.fire({
            icon: "success",
            title: `Screen ${
              type === "add" ? "added" : "updated"
            } successfully.`,
          });
          handleClose();
          getScreens();
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot Process Request" });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401)
          Toast.fire({ icon: "error", title: "Unauthorized Access" });
        console.log(err);
      });
  };

  function handleClose() {
    setIsShowing(false);
    setScreen("");
    setFloor("");
    setBuilding("");
    setCity("");
    setState("");
    setCountry("");
    setPassword("");
    // window.location.reload()
  }

  return (
    <>
      {type === "add" && (
        <button
          type="button"
          class="btn btn-dark btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-plus"></i> Add Screen
        </button>
      )}
      {type !== "add" && (
        <button
          type="button"
          class="btn btn-success btn-sm ml-1"
          title="Edit"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-pen"></i>
        </button>
      )}
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create Screen</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    {/* <AsyncSelect
                      defaultOptions
                      cacheOption
                      defaultOptions
                      placeholder="Countries"
                      value={country}
                      getOptionLabel={(e) => `${e.name} (${e.code})`}
                      getOptionValue={(e) => e._id}
                      loadOptions={fetchCountryData}
                      onInputChange={setInputCountry}
                      onChange={(e) => {
                        setCountry(e);
                        setState("");
                        setCity("");
                        setBuilding("");
                        setFloor("");
                      }}
                    /> */}
                    <div className="form-group mt-3">
                      <select onChange={(e) => setCountryOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{screenUp.country.name}</option>
                        ) : (
                          <option>Select Country---</option>
                        )}

                        {allCountry.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mt-3">
                      {/* <AsyncSelect
                        defaultOptions
                        cacheOption
                        placeholder="States"
                        value={state}
                        getOptionLabel={(e) => `${e.name}`}
                        getOptionValue={(e) => e._id}
                        loadOptions={fetchStateData}
                        onInputChange={setInputState}
                        onChange={(e) => {
                          setState(e);
                          setCity("");
                          setBuilding("");
                          setFloor("");
                        }}
                      /> */}
                      <select onChange={(e) => setStateOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{screenUp.state.name}</option>
                        ) : (
                          <option>Select State---</option>
                        )}
                        {allState.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mt-3">
                      {/* <AsyncSelect
                        defaultOptions
                        cacheOption
                        placeholder="Cities"
                        value={city}
                        getOptionLabel={(e) => `${e.name}`}
                        getOptionValue={(e) => e._id}
                        loadOptions={fetchCityData}
                        onInputChange={setInputCity}
                        onChange={(e) => {
                          setCity(e);
                          setBuilding("");
                          setFloor("");
                        }}
                      /> */}
                      <select onChange={(e) => setCityOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{screenUp.city.name}</option>
                        ) : (
                          <option>Select City---</option>
                        )}
                        {allCity?.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mt-3">
                      {/* <AsyncSelect
                        defaultOptions
                        cacheOption
                        placeholder="Buildings"
                        value={building}
                        getOptionLabel={(e) => `${e.name}`}
                        getOptionValue={(e) => e._id}
                        loadOptions={fetchBuildingData}
                        onInputChange={setInputBuilding}
                        onChange={(e) => {
                          setBuilding(e);
                          setFloor("");
                        }}
                      /> */}
                      <select onChange={(e) => setBuildingOPt(e.target.value)}>
                        {type != "add" ? (
                          <option>{screenUp.building.name}</option>
                        ) : (
                          <option>Select Building---</option>
                        )}
                        {allBuilding.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mt-3">
                      {/* <AsyncSelect
                        defaultOptions
                        cacheOption
                        placeholder="Floors"
                        value={floor}
                        getOptionLabel={(e) => `${e.name}`}
                        getOptionValue={(e) => e._id}
                        loadOptions={fetchFloorData}
                        onInputChange={setInputFloor}
                        onChange={setFloor}
                      /> */}
                      <select onChange={(e) => setFloorOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{screenUp.floor.name}</option>
                        ) : (
                          <option>Select Floor---</option>
                        )}

                        {allFloor.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control mt-3"
                        id="screen"
                        placeholder={"Enter Screen Name"}
                        value={screen}
                        onChange={(e) => setScreen(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control mt-3"
                        type="password"
                        id="password"
                        placeholder={"Enter Screen Password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={(e) => handleClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={(e) => addScreen()}
                  disabled={isLoading}
                >
                  {type === "add" ? "Add Screen" : "Save changes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
